import { Outlet } from 'react-router-dom'

import styled from 'styled-components'
import SideMenu from '../components/SideMenu'

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  overflow: hidden;
`

const Body = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
`

const Content = styled.div`
  display: flex;
  flex: 1;
  min-width: 0;
  min-height: 0;
  height: 100%;
  padding: 32px;
  gap: 32px;
  overflow: hidden;
`
const DummyWrapper = styled.div`
  flex: 0 0 240px;
  width: 240px;
`

export const Home = () => {
  return (
    <Wrapper>
      <Body>
        <SideMenu />
        <DummyWrapper />
        <Content>
          <Outlet />
        </Content>
      </Body>
    </Wrapper>
  )
}
